import Styled from "styled-components";

export const HeaderHeight = Styled.header`
`;

export const HeaderMenu = Styled.div`
`;

export const HeaderButton = Styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  width: 44px;
  height: 44px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;

  svg {
    height: 24px;
    width: 24px;
    color: white !important;
  }
`;

export const ContainerMenuHamburguer = Styled.aside`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButtonContainer = Styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Space = Styled.div`
`;

export const Container = Styled.div`
    align-items: center;
`;
export const Logo = Styled.img`
`;

export const Balance = Styled.div`
`;
export const H5 = Styled.h6`
`;

export const Block = Styled.div`
  &.header-top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;

    .header-left {
      display: flex;
      align-items: center;

      .logo-wl {
        cursor: pointer;
        max-width: 250px;
        max-height: 41px;
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /* Icon buttons are 44x44 with a 24x24 svg centered, leaving 10px of
         inner padding around the visible icon. Pull the group right by 10px
         so the icons' visible edges align with the greeting-bar text below,
         which sits at the container's 24px right padding. */
      margin-right: -10px;
    }
  }
`;

export const SearchBarContainer = Styled.div`
  background-color: #FFFFFF;
  height: 64px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 24px;
`;

export const SearchInput = Styled.div`
  background-color: #E9E9E9;
  height: 42px;
  width: 100%;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 8px;
  cursor: text;

  svg {
    width: 20px;
    height: 20px;
    color: #595959;
    flex-shrink: 0;
  }

  input {
    border: none;
    background: none;
    outline: none;
    font-size: 16px;
    color: #595959;
    line-height: 24px;
    width: 100%;
    font-family: var(--font-family);

    &::placeholder {
      color: #595959;
    }
  }
`;

export const P = Styled.p`
`;

/* ----------------------------------------------------------------------------
 * Responsividade desktop (>=1024px)
 * O markup mobile (3 faixas) fica intacto, apenas escondido no desktop.
 * O header desktop é uma linha única dedicada, escondida no mobile/tablet.
 * -------------------------------------------------------------------------- */

export const MobileHeader = Styled.div`
  @media (min-width: 1024px) {
    display: none;
  }
`;

export const DesktopHeader = Styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: block;

    .hd-inner {
      max-width: 1320px;
      margin: 0 auto;
      padding: 0 32px;
      height: 80px;
      display: flex;
      align-items: center;
      gap: 24px;
    }

    .hd-logo {
      cursor: pointer;
      max-height: 40px;
      max-width: 180px;
      flex-shrink: 0;
    }

    .hd-nav {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .hd-nav > button,
    .hdrop-toggle {
      background: none;
      border: none;
      cursor: pointer;
      color: var(--secondary-color);
      font-family: var(--font-family);
      font-size: 15px;
      font-weight: 500;
      padding: 8px 6px;
      white-space: nowrap;
      display: inline-flex;
      align-items: center;
      gap: 2px;
      transition: opacity 0.15s ease;
    }

    .hd-nav > button:hover,
    .hdrop-toggle:hover {
      opacity: 0.75;
    }

    .hd-search {
      flex: 1 1 auto;
      max-width: 460px;
      margin-left: auto;
    }

    .hd-actions {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-shrink: 0;
    }

    .hd-points {
      color: var(--secondary-color);
      font-family: var(--font-family);
      font-weight: 700;
      white-space: nowrap;
    }

    /* dropdown leve (hover/focus) para Viagens e Conta */
    .hdrop {
      position: relative;
    }

    .hdrop-menu {
      position: absolute;
      top: 100%;
      left: 0;
      min-width: 200px;
      background: #ffffff;
      border-radius: 8px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
      padding: 8px 0;
      display: none;
      z-index: 1000;
    }

    .hdrop-menu-right {
      left: auto;
      right: 0;
    }

    .hdrop:hover .hdrop-menu,
    .hdrop:focus-within .hdrop-menu {
      display: block;
    }

    .hdrop-menu button {
      display: block;
      width: 100%;
      text-align: left;
      background: none;
      border: none;
      cursor: pointer;
      padding: 10px 16px;
      font-family: var(--font-family);
      font-size: 14px;
      color: var(--primary-color);
      white-space: nowrap;
    }

    .hdrop-menu button:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }
`;
